// iRichText emits {body_text, ranges} and uses "\n" as its empty marker —
// same emptiness test as text-element-mixin's `textIsEmpty`.
function hasText(value) {
  if (typeof value === "string") {
    return value.trim() !== "";
  }
  if (value && typeof value === "object") {
    return typeof value.body_text === "string" && value.body_text !== "\n" && value.body_text.trim() !== "";
  }
  return false;
}

// Returns the text-option value UNCHANGED (rich-text object included) so
// formatting survives; legacy links still hold their text on href-action.label.
export function resolveLinkText(textOptionValue, hrefActionValue) {
  if (hasText(textOptionValue)) {
    return textOptionValue;
  }
  const legacy = hrefActionValue?.label;
  return typeof legacy === "string" ? legacy : "";
}
